module.exports = __webpack_public_path__ + "img/work_better3.68a976c3.png";